export const PHOTO_REVIEW_UISTATE = {
	IS_LOADING: 'isLoading',
	HAS_PHOTOS: 'hasPhotos',
	NO_PHOTOS: 'noPhotos',
	DEFAULT_IMG: '../../../../assets/img/avatars/noImageAvailable.png',
	NO_INFO: 'N/A',
	PROPERTY_CARD: 'PROPERTY_CARD',
	TAB_TITLES: {
		ALL: 'ALL',
		SKETCH: 'SKETCH',
		PROPERTY_CARD: 'PROPERTY CARD',
		EXTERIOR: 'EXTERIOR',
		INTERIOR: 'INTERIOR'
	},
	MESSAGETYPE: {
		INFO: 'Info',
		WARNING: 'Warning',
		ERROR: 'Error'
	},
	CARD: {
		SELECTED_CAR: 'cv-photo-car-container-selected',
		SELECTED_BTN_SRT: 'cv-btn-str-active',
		INACTIVE_BTN_SRT: 'cv-btn-str-inactive'
	}
};
